import { useCallback } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { useFormContext } from "react-hook-form";
import { Box, TextField } from "@mui/material";
import { DateTime } from "luxon";

export const HookedDatePicker = (
  props: any
) => {
  const {
    register,
    setValue,
    getFieldState,
    watch,
    formState: { errors }, // eslint-disable-line @typescript-eslint/no-unused-vars
  } = useFormContext();

  if (!props.name) return <Box />;

  const fieldValue = watch(props.name);
  const { error: startError } = getFieldState(props.name);

  // const value: any = useMemo(() => fieldValue, [fieldValue]);

  const handleChange = useCallback(
    (date: string | null) => {
      console.log("We got this date in the handleChange callback");
      console.log(date);
      setValue(props.name!, date, { shouldValidate: true });
    },
    [props.name, setValue]
  );

  return (
    <>
      <DatePicker
        {...register(props.name)}
        defaultValue={
          typeof props.defaultValue === "string"
          ? DateTime.fromFormat(props.defaultValue, "yyyy-LL-dd")
          : props.defaultValue
        }
        value={fieldValue}
        onChange={handleChange}
        slots={{ textField: TextField }}
        slotProps={{
          textField: {
            ...props,
            placeholder: "MM/YYYY",
            helperText: startError?.message || props.helperText,
          },
        }}
      />
    </>
  );
};
